module.exports = __webpack_public_path__ + "img/IB.5a65286c.jpg";